<template>
  <v-app>
    <v-img
      class="login-image"
    >
      <v-container
        class="fill-height"
        fluid
      >
        <v-app-bar
          flat
          color="transparent"
        >
          <v-list-item-avatar
            class="align-self-center"
            contain
          >
            <v-img
              :src="getIcon()"
              max-height="100%"
            />
          </v-list-item-avatar>
          <v-toolbar-title class="text-h4">
            {{ $t('avatar') }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            text
            color="#fff"
            class="v-btn--active"
            href="/login"
          >
            <v-icon
              class="mr-1"
            >
              mdi-login
            </v-icon>
            Login
          </v-btn>
        </v-app-bar>
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title
                  :class="{ hidden: updated }"
                >
                  Setup your new password
                </v-toolbar-title>
                <v-toolbar-title
                  :class="{ hidden: !updated }"
                >
                  Update success
                </v-toolbar-title>
              </v-toolbar>
              <v-progress-linear
                color="success"
                :class="{hidden: !loading }"
                indeterminate
              />
              <v-card-text
                :class="{ hidden: updated }"
              >
                <v-text-field
                  v-model="email"
                  label="Email address"
                  prepend-icon="mdi-email"
                  type="text"
                  readonly
                />
                <v-text-field
                  ref="newpassword"
                  v-model="newpassword"
                  label="New Password"
                  prepend-icon="mdi-lock"
                  type="password"
                  :rules="[
                    v => !!v || 'This is required',
                    v => ((v || '').length >= 8 && (v || '').length <= 16) || 'At least 8-16 characters long',
                    v => /[a-z]/.test((v || '')) || 'At least 1 lowercase letter',
                    v => /[A-Z]/.test((v || '')) || 'At least 1 uppercase letter',
                    v => /\d/.test((v || '')) || 'At least 1 number',
                    v => /[!@#?\$%\^\&*\)\(+=._-]/.test((v || '')) || 'At least 1 special character',
                  ]"
                  @keydown.enter="$refs.password2.focus()"
                />

                <v-text-field
                  ref="password2"
                  v-model="password2"
                  label="Confirm Password"
                  prepend-icon="mdi-lock-outline"
                  type="password"
                  :rules="[
                    v => !!v || 'This is required',
                    v => v === newpassword || 'Password confirmation not match',
                  ]"
                  @keydown.enter.prevent="VerifyAccount"
                />
              </v-card-text>
              <div
                class="px-12 text-body-1 error--text"
                :class="{ hidden: (!error || updated) }"
              >
                {{ error_text }}
              </div>
              <div
                class="px-12 text-body-1 primary--text mt-4"
                :class="{ hidden: !updated }"
              >
                Your new password has been saved!
              </div>
              <v-card-actions>
                <v-col>
                  <v-row class="px-3">
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      class="v-btn--active"
                      :class="{ hidden: updated }"
                      :disabled="loading"
                      @click="VerifyAccount"
                    >
                      Update Password
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      class="v-btn--active"
                      :class="{ hidden: !updated }"
                      href="/login"
                    >
                      Proceed to Login
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
              <br>
            </v-card>
          </v-col>
        </v-row>
        <v-row
          align="center"
          no-gutters
        >
          <v-spacer class="hidden-sm-and-down" />
          <v-col
            cols="12"
            md="auto"
            class="mr-6"
          >
            <div class="footer text-center">
              Copyright &copy; 2021 - <a href="/">McDonald's Philippines</a>.
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
  </v-app>
</template>
<style scoped>
  .footer, .footer a, .text-h4 {
    color: #fff !important;
    font-weight: 400 !important;
  }
</style>
<script>
  import { VerifyAccount } from '@/graphql/Auth.gql'
  export default {
    data () {
      return {
        token: '',
        email: '',
        signature: '',
        newpassword: '',
        password2: '',
        loading: false,
        updated: false,
        error: false,
        error_text: '',
        default_error: 'Password validation failed.',
        // rebuild
      }
    },
    mounted () {
      this.ValidateToken()
    },
    methods: {
      getIcon () {
        return window && window.location && window.location.protocol && window.location.host ? `${window.location.protocol}//${window.location.host}/favicon.png` : 'http://localhost/favicon.png'
      },
      ValidateToken () {
        if (this.$route.query.email) { this.email = this.$route.query.email }
        if (this.$route.query.signature) { this.signature = this.$route.query.signature }
        if (this.$route.params.token) { this.token = this.$route.params.token }
        this.$refs.newpassword.focus()
      },
      VerifyAccount () {
        if (this.token === '' || this.email === '' || this.signature === '' || this.newpassword === '' || this.password2 === '') { return }
        if (this.newpassword.length < 8 || this.newpassword.length > 16) { return }
        if (this.loading) { return }
        this.loading = true
        this.error = false
        this.error_text = this.default_error
        this.$apollo.mutate({
          mutation: VerifyAccount,
          variables: {
            input: {
              email: this.email,
              token: this.token,
              signature: this.signature,
              password: this.newpassword,
              password_confirmation: this.password2,
            },
          },
        }).then((res) => {
          this.loading = false
          if (res.data.VerifyAccount.status === 'Ok') {
            this.updated = true
          } else {
            if (res.data.VerifyAccount.status.toLowerCase().indexOf('reset token') > -1) {
              this.error_text = 'The token is invalid or has expired.'
            } else {
              this.error_text = res.data.VerifyAccount.status
            }
            this.error = true
          }
        }).catch(error => {
          this.loading = false
          this.error = (error)
        })
      },
    },
  }
</script>
